/**
 * Кому открыт раздел рабочего места.
 *
 * Тонкая обёртка над общими переключателями: вся раскладка живёт в
 * AccessChips, здесь только приведение к виду, который понимает API разделов.
 * Команда у разделов называется folderId, у папок быстрых ответов — teamId, и
 * это единственное различие между двумя экранами.
 */

import type { AccountFolderDto, ManagedSectionDto } from "../lib/api.js";
import { AccessChips, type GrantSubject } from "./AccessChips.tsx";

interface SectionAccessEditorProps {
  section: ManagedSectionDto;
  folders: readonly AccountFolderDto[];
  users: ReadonlyArray<{ id: string; displayName: string }>;
  busy: boolean;
  onGrant: (subject: {
    userId?: string;
    role?: string;
    folderId?: string;
  }) => void;
  onRevoke: (accessId: string) => void;
}

export function SectionAccessEditor({
  section,
  folders,
  users,
  busy,
  onGrant,
  onRevoke,
}: SectionAccessEditorProps) {
  return (
    <AccessChips
      grants={section.access.map((a) => ({
        id: a.id,
        userId: a.userId,
        role: a.role,
        teamId: a.folderId,
      }))}
      folders={folders}
      users={users}
      busy={busy}
      onGrant={(subject: GrantSubject) => {
        if (subject.kind === "user") onGrant({ userId: subject.id });
        else if (subject.kind === "role") onGrant({ role: subject.id });
        else onGrant({ folderId: subject.id });
      }}
      onRevoke={onRevoke}
    />
  );
}
